import assetIcGift from './ic-gift.svg';
import assetIcPushBellBadge from './ic-push-bell-badge.svg';
import assetIcTruck from './ic-truck.svg';
import assetIcUspAuthenticyCheck from './ic-usp-authenticy-check.svg';
import assetIlPushBellRed from './il-push-bell-red.svg';
import assetIlPushBellYellow from './il-push-bell-yellow.svg';
import assetIlPushSale from './il-push-sale.svg';
import assetIlPushTruck from './il-push-truck.svg';
export enum PushNotificationIconName {
  PushBellowYellow = 'PushBellowYellow',
  PushSale = 'PushSale',
  PushBellRed = 'PushBellRed',
  PushTruck = 'PushTruck',
  Truck = 'Truck',
  Gift = 'Gift',
  UspAuthenticityCheck = 'UspAuthenticityCheck',
  PushBellBadge = 'PushBellBadge',
}

export const pushNotificationIconAssets: {
  [key in PushNotificationIconName]: string;
} = {
  [PushNotificationIconName.PushBellowYellow]: assetIlPushBellYellow,
  [PushNotificationIconName.PushSale]: assetIlPushSale,
  [PushNotificationIconName.PushBellRed]: assetIlPushBellRed,
  [PushNotificationIconName.PushTruck]: assetIlPushTruck,
  [PushNotificationIconName.Truck]: assetIcTruck,
  [PushNotificationIconName.Gift]: assetIcGift,
  [PushNotificationIconName.UspAuthenticityCheck]: assetIcUspAuthenticyCheck,
  [PushNotificationIconName.PushBellBadge]: assetIcPushBellBadge,
};
